import { render } from "./DataTableToolSelection.vue?vue&type=template&id=56bb4cc4&scoped=true"
import script from "./DataTableToolSelection.vue?vue&type=script&lang=js"
export * from "./DataTableToolSelection.vue?vue&type=script&lang=js"

import "./DataTableToolSelection.vue?vue&type=style&index=0&id=56bb4cc4&lang=css"
import "./DataTableToolSelection.vue?vue&type=style&index=1&id=56bb4cc4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bb4cc4"]])

export default __exports__